"use strict";
// Public API for util
var decorators_1 = require('./util/decorators');
exports.Class = decorators_1.Class;
//# sourceMappingURL=util.js.map


/*****************
 ** WEBPACK FOOTER
 ** /var/www/smartwifi/shared/~/@angular/core/src/util.js
 ** module id = 44
 ** module chunks = 0 1 2
 **/